export default function AffiliateEconomyBooking() {
  return (
    <a
      href="https://www.tkqlhce.com/click-101530017-17126226"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      <img
        src="https://www.lduhtrp.net/image-101530017-17126226"
        width="200"
        height="150"
        alt="Economy Booking"
        style={{ border: 0 }}
      />
    </a>
  );
}
